<template>
    <div class="modal fade" ref="popup">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ trans("Confirm Action") }}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-default"
                            data-dismiss="modal" @click="callCb('cancelCb')">
                        {{ trans("Cancel") }}
                    </button>
                    <button type="button" class="btn btn-outline-success"
                            data-dismiss="modal" @click="callCb('confirmCb')">
                        {{ trans("Yes") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            confirmCb: null,
            cancelCb: null
        };
    },
    methods: {
        show(confirmCb, cancelCb) {
            this.confirmCb = confirmCb;
            this.cancelCb = cancelCb;
            $('.modal').modal('hide');
            $('.modal-backdrop').remove();
            let modal = $(this.$refs.popup).modal();
        },
        callCb(cbName) {
            if (typeof this[cbName] === "function") {
                this[cbName]();
            }
        }
    }
}
</script>